<template>
	<div class="action-bar">

		<!-- Mobile: v-menu -->
		<v-menu v-if="$vuetify.breakpoint.mobile" bottom offset-y rounded="lg">
			<template v-slot:activator="{ on, attrs }">
				<button class="action-btn btn-menu-trigger" v-bind="attrs" v-on="on">
					<v-icon size="18" color="white">mdi-dots-grid</v-icon>
					<span>Opciones</span>
					<v-icon size="14" color="white">mdi-chevron-down</v-icon>
				</button>
			</template>
			<v-list dense class="mobile-menu-list">
				<!-- Vista -->
				<v-subheader class="menu-subheader">Vista</v-subheader>
				<v-list-item @click="$store.projectsStore.commit('setListingType', 1)" :class="{ 'menu-item--active': listingType === 1 }">
					<v-list-item-icon class="mr-3">
						<v-icon size="18" :color="listingType === 1 ? '#5E85EF' : '#999'">mdi-grid-large</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Cuadrícula</v-list-item-title>
					</v-list-item-content>
					<v-icon v-if="listingType === 1" size="14" color="#5E85EF">mdi-check</v-icon>
				</v-list-item>
				<v-list-item disabled>
					<v-list-item-icon class="mr-3">
						<v-icon size="18" color="#CCC">mdi-table</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color:#CCC">Gerencial <small>(próximamente)</small></v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-divider class="my-1" v-if="checkCompanyLevelPermissions(['edit_project']) || checkCompanyLevelPermissions(['create_project'])"></v-divider>

				<!-- Acciones -->
				<v-subheader class="menu-subheader" v-if="checkCompanyLevelPermissions(['edit_project']) || checkCompanyLevelPermissions(['create_project'])">Acciones</v-subheader>
				<v-list-item
					v-if="checkCompanyLevelPermissions(['edit_project'])"
					@click="$store.projectsStore.commit('setEditProjectModal', true)"
				>
					<v-list-item-icon class="mr-3">
						<v-icon size="18" color="#F4A943">mdi-pencil-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Editar</v-list-item-title>
						<v-list-item-subtitle>Proyecto Activo</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					v-if="checkCompanyLevelPermissions(['create_project'])"
					@click="$store.projectsStore.commit('setNewProjectModal', true)"
				>
					<v-list-item-icon class="mr-3">
						<v-icon size="18" color="#2D4B95">mdi-plus-circle-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Crear Nuevo</v-list-item-title>
						<v-list-item-subtitle>Proyecto</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-menu>

		<!-- Desktop -->
		<template v-else>
			<!-- Vista -->
			<div class="btn-group">
				<button
					class="action-btn"
					:class="{ active: listingType === 1 }"
					@click="$store.projectsStore.commit('setListingType', 1)"
					title="Vista Cuadrícula"
				>
					<v-icon :size="16" :color="listingType === 1 ? 'white' : '#5E85EF'">mdi-grid-large</v-icon>
					<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
						<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Vista</p>
						<p class="mb-0">Cuadrícula</p>
					</div>
				</button>
				<button
					class="action-btn"
					:class="{ active: listingType === 3 }"
					disabled
					title="Vista Gerencial (próximamente)"
				>
					<v-icon :size="16" color="#AAAAAA">mdi-table</v-icon>
					<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
						<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Vista</p>
						<p class="mb-0">Gerencial</p>
					</div>
				</button>
			</div>

			<div class="btn-divider" v-if="checkCompanyLevelPermissions(['edit_project']) || checkCompanyLevelPermissions(['create_project'])"></div>

			<!-- Acciones -->
			<div class="btn-group btn-group--actions">
				<button
					class="action-btn btn-edit"
					v-if="checkCompanyLevelPermissions(['edit_project'])"
					@click="$store.projectsStore.commit('setEditProjectModal', true)"
					title="Editar Proyecto"
				>
					<v-icon size="16" color="white">mdi-pencil-outline</v-icon>
					<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
						<p class="mb-0">Editar</p>
						<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Proyecto Activo</p>
					</div>
				</button>
				<button
					class="action-btn btn-new"
					v-if="checkCompanyLevelPermissions(['create_project'])"
					@click="$store.projectsStore.commit('setNewProjectModal', true)"
					title="Nuevo Proyecto"
				>
					<v-icon size="16" color="white">mdi-plus-circle-outline</v-icon>
					<div class="d-flex flex-column align-items-start text-left" style="line-height: 1;">
						<p class="mb-0">Crear Nuevo</p>
						<p class="mb-0" style="font-size: 10px;opacity: 0.6;">Proyecto</p>
					</div>
				</button>
			</div>
		</template>

	</div>
</template>

<script>
import {checkCompanyLevelPermissions} from '@/helpers/permissions'

export default {
	name: 'ProjectActionButtons',
	computed: {
		listingType() {
			return this.$store.projectsStore.state.listingType
		}
	},
	data: () => ({}),
	methods: { checkCompanyLevelPermissions }
};
</script>

<style scoped>
.action-bar {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
}
.btn-group {
	display: inline-flex;
	align-items: center;
	background: #EEF1FB;
	border-radius: 10px;
	padding: 4px;
	gap: 2px;
}
.btn-divider {
	width: 1px;
	height: 24px;
	background: #DCDFE8;
	flex-shrink: 0;
}
.action-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 13px;
	border-radius: 6px;
	border: none;
	background: #2D4B95;
	cursor: pointer;
	font-size: 13px;
	font-family: inherit;
	color: white;
	transition: background 0.15s, color 0.15s;
	white-space: nowrap;
	line-height: 1;
}
.action-btn:hover:not(:disabled) {
	background: rgba(94, 133, 239, 0.12);
	color: #2D4B95;
}
.action-btn.active {
	background: #2D4B95;
	color: white;
}
.action-btn.btn-edit { background: #F4A943 !important; color: white !important; }
.action-btn.btn-edit span { color: white !important; }
.action-btn.btn-edit:hover:not(:disabled) { background: #e09530 !important; }
.action-btn.btn-new { background: #2D4B95 !important; color: white !important; }
.action-btn.btn-new span { color: white !important; }
.action-btn.btn-new:hover:not(:disabled) { background: #243d7a !important; }
.action-btn.btn-menu-trigger {
	background: linear-gradient(135deg, #5E85EF 0%, #2D4B95 100%) !important;
	color: white !important;
	gap: 6px;
	padding: 7px 14px;
}
.mobile-menu-list {
	min-width: 200px;
}
.menu-subheader {
	font-size: 10px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: #999;
	height: 28px;
}
.menu-item--active {
	background: #EEF1FB;
}
.btn-group--actions {
	background: transparent;
	padding: 0;
	gap: 6px;
}
.action-btn:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>
